// extracted by mini-css-extract-plugin
export var fadeInOut = "_10-3";
export var icon = "_10-4";
export var savedIndicator = "_10-2";
export var savingIndicator = "_10-0";
export var spin = "_10-1";